<ul [id]="id">
  @for (item of items; track $index) {
  <li>
    @if((item?.children?.length??0) > 0) {
    <button type="button"
            role="menuitem"
            onclick="this.hasAttribute('open') ? this.removeAttribute('open'):  this.setAttribute('open','');">{{ item.title }}</button>
    <app-nav-fragment [items]="item.children ?? []"
                      [id]="item.id ?? id+'-'+$index+''"
                      role="group"
                      [level]="level+1"></app-nav-fragment>
    } @else if ( item.media != null) {
    <div class="media"
         role="img"
         [attr.aria-labelledby]="'title-'+item.id"
         [attr.aria-describedby]="'description-'+item.id">
      <img [use]="item.media"
           size="menu"
           role="presentation">
      <span [id]="'title-'+item.id"
            role="heading"
            aria-level="4">{{item.title}}</span>
      <span [id]="'description-'+item.id">{{item.description}}</span>
    </div>
    } @else if (item.link == null) {
    <span role="heading"
          [attr.aria-level]="level">{{ item.title }}</span>
    } @else {
    <a [href]="item.link"
       role="menuitem"
       [attr.target]="item.target">{{ item.title }}</a>
    }
  </li>
  }
</ul>
